const appConfig = {
  apiRoot: window.apiPrefix,
  apiPrefix: '/api',
  reportUrl: window.reportUrl,
  authenticatedEntryPath: '/app/inventory/catalog',
  unAuthenticatedEntryPath: '/sign-in',
  tourPath: '/app/account/kyc-form',
  locale: 'en',
  enableMock: true,
  version: window.appVersion,
  currency: window.currency,
  S3: window.S3,
  storage: window.storage,
  _version: '25.8.2'
}

export default appConfig
